import { FrameCache } from './frame-cache';
import { VideoFrameTracker } from './video-frame-tracker';

/**
 * Объединяет две части оптимизации перерисовки в рекордере:
 *   - VideoFrameTracker — отвечает на вопрос «у каких видео был новый кадр»;
 *   - FrameCache       — хранит готовые отрисованные кадры по слотам.
 *
 * Создаётся при старте записи через enableRvfcSkip, уничтожается через
 * clearRvfcSkip. Между ними drawer на каждом кадре зовёт beforeDraw перед
 * отрисовкой.
 */
export class RvfcSkipOptimizer {
    private readonly _tracker: VideoFrameTracker;
    private readonly _cache: FrameCache;
    private _dirtySet: Set<HTMLVideoElement> = new Set();

    constructor() {
        this._cache = new FrameCache();
        this._tracker = new VideoFrameTracker(true, (video) => this._cache.remove(video));
    }

    beforeDraw(
        participantCount: number,
        activeGridView: string,
        currentPage: number,
        isScreenSharingActive: boolean
    ): void {
        this._tracker.checkLayoutChange(participantCount, activeGridView, currentPage, isScreenSharingActive);
        this._dirtySet = this._tracker.consumeDirty();
    }

    getDirtySet(): ReadonlySet<HTMLVideoElement> {
        return this._dirtySet;
    }

    getFrameCache(): FrameCache {
        return this._cache;
    }

    destroy(): void {
        this._tracker.destroy();
        this._cache.destroy();
    }
}

let rvfcOptimizer: RvfcSkipOptimizer | null = null;

export function enableRvfcSkip() {
    rvfcOptimizer = new RvfcSkipOptimizer();
}

export function clearRvfcSkip() {
    rvfcOptimizer?.destroy();
    rvfcOptimizer = null;
}

export function getRvfcOptimizer(): RvfcSkipOptimizer | null {
    return rvfcOptimizer;
}
